import { observable, IObservableObject } from 'mobx';

export const syncTransactions: IObservableObject = observable({});
